module.exports = __webpack_public_path__ + "3fbfe9d6355db171141a90c36b35b5e3.MP3";